import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import Badge from '@mui/material/Badge';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  useTheme,
  // Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import logo from '../../resource/images/logo.png';
import { request } from './utils';
import NotificationDropdown from '../notification/notification-dropdown';

const useStyles = (theme) => ({
  topContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toolbarContainer: {
    height: '60px',
    '@media (min-width: 320px)': {
      height: '100px',
    },
  },
  logoContainer: {
    flexGrow: 1,
    userSelect: 'none',
  },
  logo: {
    color: 'white',
    width: 150,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginBottom: '5px', // The logo is not vertically centered without this
    [theme.breakpoints.up('sm')]: {
      width: 200,
    },
  },
  vendorDashboardButton: {
    color: 'white',
  },
  becomeVendorButton: {
    color: 'white',
  },
  navbarIcon: {
    color: '#FFFFFF',
    paddingRight: 1.5,
  },
});

function NavBarMobile(props) {
  const {
    accountMenuAnchorEl,
    onClickAccount,
    closeAccountMenu,
    openSignInDialog,
    user,
    toggleDrawerOpen,
    unreadNotificationCount,
    unreadChatCount,
    cartItemCount,
  } = props;

  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [notifications, setNotifications] = useState([]);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const isNotificationDropdownOpen = Boolean(notificationAnchorEl);

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  // Function to fetch notifications
  const fetchNotifications = () => {
    request('/get-push-notifications', 'GET')
      .then((res) => {
        setNotifications(res.data); // Assuming 'data' contains the notifications
      })
      .catch((err) => {
        console.error('Error fetching notifications:', err);
      });
  };

  useEffect(() => {
    console.log(user);
    if (isNotificationDropdownOpen) {
      fetchNotifications();
    }
  }, [isNotificationDropdownOpen]);

  const redirectToHome = () => {
    navigate('/');
  };

  const redirectToChat = () => {
    navigate('/chat');
  };

  const redirectToCart = () => {
    navigate('/cart');
  };

  return (
    <Box sx={styles.topContainer}>
      <AppBar position="static">
        <Toolbar sx={styles.toolbarContainer}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
          <Box component="div" sx={styles.logoContainer}>
            <Box
              component="img"
              src={logo}
              alt="Rentovault"
              sx={styles.logo}
              onClick={redirectToHome}
            />
          </Box>

          { user && user.id && (
            <IconButton sx={styles.navbarIcon} onClick={handleNotificationClick}>
              <Badge badgeContent={unreadNotificationCount} color="warning">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          )}

          { user && user.id && (
            <IconButton sx={styles.navbarIcon} onClick={redirectToChat}>
              <Badge badgeContent={unreadChatCount} color="warning">
                <ChatRoundedIcon />
              </Badge>
            </IconButton>
          )}

          { user && user.id && (
            <IconButton sx={styles.navbarIcon} onClick={redirectToCart}>
              <Badge badgeContent={cartItemCount} color="warning">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          )}

          <Menu
            anchorEl={accountMenuAnchorEl}
            open={Boolean(accountMenuAnchorEl)}
            onClose={closeAccountMenu}
          >
            <MenuItem onClick={openSignInDialog}>Sign in</MenuItem>
            <MenuItem onClick={() => onClickAccount(user)}>Sign up</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <NotificationDropdown
        anchorEl={notificationAnchorEl}
        open={isNotificationDropdownOpen}
        onClose={handleNotificationClose}
        notifications={notifications}
        setNotifications={setNotifications}
      />
    </Box>
  );
}

NavBarMobile.propTypes = {
  accountMenuAnchorEl: PropTypes.oneOfType([PropTypes.elementType]),
  onClickAccount: PropTypes.func.isRequired,
  closeAccountMenu: PropTypes.func.isRequired,
  openSignInDialog: PropTypes.func.isRequired,
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired,
  unreadNotificationCount: PropTypes.number,
  unreadChatCount: PropTypes.number.isRequired,
  cartItemCount: PropTypes.number,
};

NavBarMobile.defaultProps = {
  unreadNotificationCount: 0,
  cartItemCount: 0,
  accountMenuAnchorEl: null,
};

export default NavBarMobile;
